document.addEventListener("DOMContentLoaded", () => {
    let psTimerInterval = null;
    let psSecondsElapsed = 0;
    let currentQuestionIndex = 1;

    // 1. Capture Page Land Time
    const personalInfoStartTime = Date.now();
    let workdayImportDurationFormatted = "0 seconds";

    // Detect User's Local Timezone dynamically
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

    // Helper function to format timestamp in User's Local Timezone with IST/EST/BST labels
    function formatUserLocalTime(date = new Date()) {
        const formattedDate = new Intl.DateTimeFormat('en-US', {
            timeZone: userTimeZone,
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).format(date);

        const timeZoneAbbr = new Intl.DateTimeFormat('en-US', {
            timeZone: userTimeZone,
            timeZoneName: 'short'
        }).formatToParts(date).find(part => part.type === 'timeZoneName')?.value || '';

        // India ke cases me 'GMT+5:30' ko clear 'IST' me map karne ke liye fallback
        const finalZone = (timeZoneAbbr.includes('GMT+5:30') || userTimeZone === 'Asia/Kolkata') ? 'IST' : timeZoneAbbr;

        return `${formattedDate} ${finalZone}`;
    }

    // Helper function to format short date-time according to User's Local Timezone
    function formatShortUserLocationTime(date = new Date()) {
        const monthShort = new Intl.DateTimeFormat('en-US', { timeZone: userTimeZone, month: 'short' }).format(date);
        const day = new Intl.DateTimeFormat('en-US', { timeZone: userTimeZone, day: 'numeric' }).format(date);
        const time = new Intl.DateTimeFormat('en-US', {
            timeZone: userTimeZone,
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).format(date);

        const timeZoneAbbr = new Intl.DateTimeFormat('en-US', {
            timeZone: userTimeZone,
            timeZoneName: 'short'
        }).formatToParts(date).find(part => part.type === 'timeZoneName')?.value || '';

        const finalZone = (timeZoneAbbr.includes('GMT+5:30') || userTimeZone === 'Asia/Kolkata') ? 'IST' : timeZoneAbbr;

        return `${day} ${monthShort} - ${time} ${finalZone}`;
    }

    // Phone input selection and number-only typing restriction
    const phoneInput = document.getElementById('phone');
    if (phoneInput) {
        // Sirf numbers (0-9) type karne dega, Baaki characters ignore kar dega
        phoneInput.addEventListener('input', (e) => {
            e.target.value = e.target.value.replace(/\D/g, '');
        });
    }

    // Dynamically count total questions present in the HTML template
    const totalQuestions = document.querySelectorAll('.ps-q-item').length;

    const assessmentMetadata = {
        client_id: "client-" + Math.floor(1000 + Math.random() * 9000),
        started_time: null,
        completed_time: null,
        browser_name: "Fetching...",
        ip_address: "",
        vpn_connected: false,
        location_with_timezone: userTimeZone
    };

    // Retrieve Browser Info using getDeviceInfo()
    async function getBrowserName() {
        try {
            const deviceInfo = await getDeviceInfo();
            return deviceInfo.display;
        } catch (error) {
            console.error("Failed to fetch device info:", error);
            return navigator.userAgent;
        }
    }

    // Set browser info asynchronously
    getBrowserName().then(browserInfo => {
        assessmentMetadata.browser_name = browserInfo;
    });

    // Retrieve IP Address using Core JS WebRTC
    function getClientIPCoreJS() {
        return new Promise((resolve) => {
            const pc = new RTCPeerConnection({ iceServers: [] });
            pc.createDataChannel("");
            pc.createOffer().then(offer => pc.setLocalDescription(offer)).catch(() => resolve("103.21.124.10"));

            pc.onicecandidate = (ice) => {
                if (!ice || !ice.candidate || !ice.candidate.candidate) {
                    resolve("103.21.124.10");
                    return;
                }
                const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
                const match = ipRegex.exec(ice.candidate.candidate);
                if (match) {
                    resolve(match[1]);
                    pc.onicecandidate = null;
                    pc.close();
                }
            };

            // Fallback timeout if WebRTC IP lookup is blocked by browser settings
            setTimeout(() => resolve("103.21.124.10"), 1000);
        });
    }

    // Set client IP via Core JS
    getClientIPCoreJS().then(ip => {
        assessmentMetadata.ip_address = ip;
    });

    // Initialize Event Listeners
    const startBtn = document.getElementById("psStartBtn");
    const prevBtn = document.getElementById("psPrevQBtn");
    const nextBtn = document.getElementById("psNextQBtn");
    const submitBtn = document.getElementById("psSubmitBtn");

    if (startBtn) startBtn.addEventListener("click", psStartAssessment);
    if (prevBtn) prevBtn.addEventListener("click", () => psNavQuestion(-1));
    if (nextBtn) nextBtn.addEventListener("click", () => psNavQuestion(1));
    if (submitBtn) submitBtn.addEventListener("click", psSubmitForm);

    function psStartAssessment() {
        const firstName = document.getElementById('first_name');
        const lastName = document.getElementById('last_name');
        const email = document.getElementById('email');
        const phone = document.getElementById('phone');
        const smsConsent = document.querySelector('input[name="sms_consent"]:checked');

        // Mandatory fields check
        if (!firstName.value.trim() || !lastName.value.trim() || !email.value.trim() || !phone.value.trim() || !smsConsent) {
            showError("Please fill in all mandatory fields before proceeding.");
            if (!firstName.value.trim()) firstName.focus();
            else if (!lastName.value.trim()) lastName.focus();
            else if (!email.value.trim()) email.focus();
            else if (!phone.value.trim()) phone.focus();
            return;
        }

        // Phone Number Digits Only & Length Validation (10-15 digits)
        const phoneDigitsOnly = phone.value.trim();
        const phoneRegex = /^[0-9]{10,15}$/;
        if (!phoneRegex.test(phoneDigitsOnly)) {
            showError("Please enter a valid phone number containing only numbers (10 to 15 digits).");
            phone.focus();
            return;
        }

        clearStatusMessage();

        // Calculate exact Personal Information filling time
        const personalInfoEndTime = Date.now();
        const durationInSeconds = Math.max(1, Math.floor((personalInfoEndTime - personalInfoStartTime) / 1000));

        if (durationInSeconds >= 60) {
            const mins = Math.floor(durationInSeconds / 60);
            const secs = durationInSeconds % 60;
            workdayImportDurationFormatted = `${mins} minute${mins > 1 ? 's' : ''}, ${secs} second${secs !== 1 ? 's' : ''}`;
        } else {
            workdayImportDurationFormatted = `${durationInSeconds} second${durationInSeconds !== 1 ? 's' : ''}`;
        }

        const now = new Date();
        assessmentMetadata.started_time = formatUserLocalTime(now);
        assessmentMetadata.started_time_formatted = formatShortUserLocationTime(now);

        const step1 = document.querySelector('.ps-step-section[data-step="1"]');
        const step2 = document.querySelector('.ps-step-section[data-step="2"]');
        const badge1 = document.getElementById('badge-step-1');
        const badge2 = document.getElementById('badge-step-2');

        step1.classList.remove('active');
        step1.setAttribute('aria-hidden', 'true');

        step2.classList.add('active');
        step2.setAttribute('aria-hidden', 'false');

        badge1.classList.remove('active');
        badge1.setAttribute('aria-selected', 'false');

        badge2.classList.add('active');
        badge2.setAttribute('aria-selected', 'true');

        psSecondsElapsed = 0;
        psTimerInterval = setInterval(() => {
            psSecondsElapsed++;
            let mins = Math.floor(psSecondsElapsed / 60);
            let secs = psSecondsElapsed % 60;
            const timerEl = document.getElementById('psTimerDisplay');
            if (timerEl) {
                timerEl.innerText = `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
            }
        }, 1000);

        psUpdateQuestionVisibility();
    }

    function psNavQuestion(direction) {
        if (direction === 1) {
            const activeQ = document.querySelector(`.ps-q-item[data-qindex="${currentQuestionIndex}"]`);
            const currentSelected = activeQ ? activeQ.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked, select, input[type="text"]') : null;

            if (currentSelected && currentSelected.type === 'radio' && !currentSelected.checked) {
                showError(`Please select an answer for Question ${currentQuestionIndex} before proceeding.`);
                return;
            } else if (!currentSelected) {
                showError(`Please select an answer for Question ${currentQuestionIndex} before proceeding.`);
                return;
            }
        }

        clearStatusMessage();
        currentQuestionIndex += direction;
        if (currentQuestionIndex < 1) currentQuestionIndex = 1;
        if (currentQuestionIndex > totalQuestions) currentQuestionIndex = totalQuestions;
        psUpdateQuestionVisibility();
    }

    function psUpdateQuestionVisibility() {
        document.querySelectorAll('.ps-q-item').forEach(el => {
            el.style.display = 'none';
            el.setAttribute('aria-hidden', 'true');
        });

        const activeQ = document.querySelector(`.ps-q-item[data-qindex="${currentQuestionIndex}"]`);

        if (activeQ) {
            activeQ.style.display = 'block';
            activeQ.setAttribute('aria-hidden', 'false');

            const labelEl = activeQ.querySelector('.ps-question-label');
            if (labelEl) {
                let text = labelEl.innerText.replace(/^\d+\.\s*/, '').trim();
                labelEl.innerText = `${currentQuestionIndex}. ${text}`;
            }

            const legend = activeQ.querySelector('legend, h4');
            if (legend) {
                legend.setAttribute('tabindex', '-1');
                legend.focus();
            }
        }

        if (prevBtn) prevBtn.style.visibility = (currentQuestionIndex === 1) ? 'hidden' : 'visible';

        if (currentQuestionIndex === totalQuestions) {
            if (nextBtn) nextBtn.style.display = 'none';
            if (submitBtn) submitBtn.style.display = 'inline-block';
        } else {
            if (nextBtn) nextBtn.style.display = 'inline-block';
            if (submitBtn) submitBtn.style.display = 'none';
        }
    }

    function getQuestionData(questionIndex) {
        const container = document.querySelector(`.ps-q-item[data-qindex="${questionIndex}"]`);
        let rawQuestionText = container?.querySelector('.ps-question-label')?.innerText.trim() || "";

        const cleanQuestionText = rawQuestionText.replace(/^\d+\.\s*/, '');
        const selectedInput = container?.querySelector('input:checked, select, input[type="text"]');
        const answerValue = selectedInput ? selectedInput.value : "N/A";

        return {
            question: `${questionIndex}. ${cleanQuestionText}`,
            raw_question: cleanQuestionText,
            answer: answerValue
        };
    }

    function showError(message) {
        const statusEl = document.getElementById('psStatusMsg');
        if (statusEl) {
            statusEl.innerHTML = `<div class="ps-alert ps-alert-danger" role="alert">⚠️ ${message}</div>`;
            statusEl.focus();
        }
    }

    function clearStatusMessage() {
        const statusEl = document.getElementById('psStatusMsg');
        if (statusEl) statusEl.innerHTML = '';
    }

    function restoreFormOnFailure() {
        const formContainer = document.getElementById('psMultiStepForm');
        const progressContainer = document.querySelector('.ps-step-progress');
        if (formContainer) formContainer.style.display = 'block';
        if (progressContainer) progressContainer.style.display = 'flex';
    }

    async function psSubmitForm() {
        const activeQ = document.querySelector(`.ps-q-item[data-qindex="${totalQuestions}"]`);
        const lastSelected = activeQ ? activeQ.querySelector('input:checked, select, input[type="text"]') : null;
        const nonceValue = document.getElementById('ps_nonce').value;

        if (!lastSelected || (lastSelected.type === 'radio' && !lastSelected.checked)) {
            showError(`Please select an answer for question ${totalQuestions}.`);
            return;
        }

        clearInterval(psTimerInterval);

        assessmentMetadata.completed_time = formatUserLocalTime(new Date());

        const mins = Math.floor(psSecondsElapsed / 60);
        const secs = psSecondsElapsed % 60;
        const timeTakenFormatted = `${mins} minutes, ${secs} seconds`;
        const form_ids = Math.floor(1000000000 + Math.random() * 9000000000);

        const jobTitle = document.querySelector('.psJobRole')?.innerText.trim() || "N/A";

        const assessmentAnswers = {};
        for (let i = 1; i <= totalQuestions; i++) {
            assessmentAnswers[`q${i}`] = getQuestionData(i);
        }

        const apiPayload = {
            client_id: assessmentMetadata.client_id,
            form_id: form_ids,
            job_title: jobTitle,
            first_name: document.getElementById('first_name').value.trim(),
            last_name: document.getElementById('last_name').value.trim(),
            email: document.getElementById('email').value.trim(),
            phone: document.getElementById('phone').value.trim(),
            sms_consent: document.querySelector('input[name="sms_consent"]:checked')?.value || "No",
            workday_import_duration: workdayImportDurationFormatted, // Personal Info filling duration
            assessment_duration: timeTakenFormatted,
            browser_name: assessmentMetadata.browser_name,
            ip_address: assessmentMetadata.ip_address,
            vpn_connected: "No",
            started_time: assessmentMetadata.started_time,
            completed_time: assessmentMetadata.completed_time,
            location_with_time: assessmentMetadata.started_time_formatted,
            assessment_answers: assessmentAnswers
        };

        const formContainer = document.getElementById('psMultiStepForm');
        const progressContainer = document.querySelector('.ps-step-progress');
        const statusContainer = document.getElementById('psStatusMsg');

        try {
            if (formContainer) formContainer.style.display = 'none';
            if (progressContainer) progressContainer.style.display = 'none';
            statusContainer.innerHTML = `<div class="ps-loading" role="status">Submitting Assessment Data...</div>`;

            const response = await fetch('/wp-json/ps/v1/submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': nonceValue
                },
                body: JSON.stringify(apiPayload)
            });

            const apiResponse = await response.json();

            if (!response.ok || apiResponse.status === "error") {
                const errorMessage = apiResponse.message || "A record with this information already exists.";

                restoreFormOnFailure();

                statusContainer.innerHTML = `
                    <div class="ps-alert ps-alert-danger" role="alert">
                        <h4>❌ Submission Failed</h4>
                        <p>${errorMessage}</p>
                        ${apiResponse.candidate_id ? `<p><small>Candidate ID: ${apiResponse.candidate_id}</small></p>` : ''}
                    </div>
                `;
                statusContainer.focus();
                return;
            }

            statusContainer.innerHTML = `
                <div class="ps-alert ps-alert-success" role="status">
                    ✓ Application Submitted Successfully!
                </div>

                <div class="ps-summary-card" tabindex="-1" id="psSummarySection">
                    <h4>Candidate Summary</h4>
                    <div class="ps-summary-row"><strong>Candidate ID:</strong> <span>${apiResponse.candidate_id || apiPayload.form_id}</span></div>
                    <div class="ps-summary-row"><strong>Job Title:</strong> <span>${apiPayload.job_title}</span></div>
                    <div class="ps-summary-row"><strong>Full Name:</strong> <span>${apiPayload.first_name} ${apiPayload.last_name}</span></div>
                    <div class="ps-summary-row"><strong>Email:</strong> <span>${apiPayload.email}</span></div>
                    <div class="ps-summary-row"><strong>Phone:</strong> <span>${apiPayload.phone}</span></div>
                    <div class="ps-summary-row"><strong>SMS Consent:</strong> <span>${apiPayload.sms_consent}</span></div>
                    <div class="ps-summary-row"><strong>Personal Details Duration:</strong> <span>${apiPayload.workday_import_duration}</span></div>
                    <div class="ps-summary-row"><strong>Assessment Duration:</strong> <span>${apiPayload.assessment_duration}</span></div>
                </div>
            `;

            document.getElementById('psSummarySection')?.focus();
        } catch (error) {
            console.error('Submission error:', error);
            restoreFormOnFailure();

            statusContainer.innerHTML = `
                <div class="ps-alert ps-alert-danger" role="alert">
                    ❌ Unable to connect to the server. Please check your network connection and try again.
                </div>
            `;
            statusContainer.focus();
        }
    }
});

async function getDeviceInfo() {
    const ua = navigator.userAgent;
    let browser = "Unknown";
    let browserVersion = "Unknown";
    let os = "Unknown";
    let osVersion = "Unknown";
    let device = "Unknown";
    let deviceModel = "Unknown";

    // DEVICE
    const isIPhone = /iPhone/i.test(ua);
    const isIPad = /iPad/i.test(ua);

    if (isIPhone) {
        device = "iPhone";
        deviceModel = "iPhone";
    } else if (isIPad) {
        device = "iPad";
        deviceModel = "iPad";
    } else if (/Android/i.test(ua)) {
        device = /Mobile/i.test(ua) ? "Mobile" : "Tablet";
        const androidMatch = ua.match(
            /Android[^;)]*;\s*(?:[a-z]{2,3}(?:-[A-Z]{2,3})?;\s*)?([^;)]+?)(?:\s+Build\/[^;)]+)?[;)]/i
        );

        if (androidMatch) {
            deviceModel = androidMatch[1].trim();
        }
    } else {
        device = "Desktop";
    }

    // OPERATING SYSTEM
    if (/iPhone|iPad|iPod/i.test(ua)) {
        os = "iOS";
        const iosMatch = ua.match(/OS (\d+(?:[_\.]\d+)*)/i);
        if (iosMatch) {
            osVersion = iosMatch[1].replace(/_/g, ".");
        }
    } else if (/Android/i.test(ua)) {
        os = "Android";
        const androidMatch = ua.match(/Android\s+([\d.]+)/i);
        if (androidMatch) {
            osVersion = androidMatch[1];
        }
    } else if (/Windows NT/i.test(ua)) {
        os = "Windows";
        const windowsVersions = {
            "10.0": "10/11",
            "6.4": "10/11",
            "6.3": "8.1",
            "6.2": "8",
            "6.1": "7",
            "6.0": "Vista",
            "5.1": "XP"
        };
        const match = ua.match(/Windows NT ([\d.]+)/i);
        if (match) {
            osVersion = windowsVersions[match[1]] || match[1];
        }
    } else if (/Mac OS X/i.test(ua)) {
        os = "macOS";
        const macMatch = ua.match(/Mac OS X\s*([\d_\.]+)/i);
        if (macMatch) {
            osVersion = macMatch[1].replace(/_/g, ".");
        }
    } else if (/CrOS/i.test(ua)) {
        os = "ChromeOS";
        const chromeOSMatch = ua.match(/CrOS [^ ]+\s+([\d.]+)/i);
        if (chromeOSMatch) {
            osVersion = chromeOSMatch[1];
        }
    } else if (/Linux/i.test(ua)) {
        os = "Linux";
    }

    // BROWSER
    let match = ua.match(/Edg(?:A|iOS)?\/([\d.]+)/i);
    if (match) {
        browser = "Edge";
        browserVersion = match[1];
    } else if ((match = ua.match(/OPR\/([\d.]+)/i))) {
        browser = "Opera";
        browserVersion = match[1];
    } else if ((match = ua.match(/SamsungBrowser\/([\d.]+)/i))) {
        browser = "Samsung Internet";
        browserVersion = match[1];
    } else if ((match = ua.match(/(?:Firefox)\/([\d.]+)/i))) {
        browser = "Firefox";
        browserVersion = match[1];
    } else if ((match = ua.match(/(?:Chrome|CriOS)\/([\d.]+)/i))) {
        browser = "Chrome";
        browserVersion = match[1];
    } else if ((match = ua.match(/(?:MSIE\s|IEMobile\/)([\d.]+)/i))) {
        browser = "Internet Explorer";
        browserVersion = match[1];
    } else if (/Safari/i.test(ua)) {
        browser = "Safari";
        match = ua.match(/Version\/([\d.]+)/i);
        if (match) {
            browserVersion = match[1];
        }
    }

    // iOS DEVICE NAME
    if (isIPhone) {
        deviceModel = "iPhone";
    } else if (isIPad) {
        deviceModel = "iPad";
    }

    // USER AGENT DATA API
    let uaData = null;
    if (navigator.userAgentData) {
        try {
            uaData = await navigator.userAgentData.getHighEntropyValues([
                "architecture",
                "model",
                "platform",
                "platformVersion",
                "fullVersionList"
            ]);

            if (uaData.model) {
                deviceModel = uaData.model;
            }

            if (uaData.platform) {
                os = uaData.platform;
            }

            if (uaData.platformVersion) {
                osVersion = uaData.platformVersion;
            }

            if (uaData.fullVersionList?.length) {
                const brands = uaData.fullVersionList;
                const preferredBrowser =
                    brands.find(x =>
                        /Google Chrome|Microsoft Edge|Opera|Samsung Internet/i.test(x.brand)
                    );

                if (preferredBrowser) {
                    browserVersion = preferredBrowser.version;

                    if (/Google Chrome/i.test(preferredBrowser.brand)) {
                        browser = "Chrome";
                    } else if (/Microsoft Edge/i.test(preferredBrowser.brand)) {
                        browser = "Edge";
                    } else if (/Opera/i.test(preferredBrowser.brand)) {
                        browser = "Opera";
                    } else if (/Samsung Internet/i.test(preferredBrowser.brand)) {
                        browser = "Samsung Internet";
                    }
                }
            }
        } catch (e) {
            // Fall back to User-Agent detection
        }
    }

    // MOBILE
    const isMobile = /Mobile|iPhone|iPad|iPod|Android/i.test(ua);

    // RESULT
    const result = {
        browser,
        browserVersion,
        device,
        deviceModel,
        operatingSystem: os,
        operatingSystemVersion: osVersion,
        mobile: isMobile,
        userAgent: ua
    };

    result.display = `${browser}${isMobile ? " Mobile" : ""} ${browserVersion} (${deviceModel}, ${os} ${osVersion})`;

    return result;
}